<template>
  <div>
    <v-container class="py-0 px-0">
      <v-data-table
        :headers="TTPBBelumKembaliHeaders"
        :items="TTPBBelumKembali"
        :loading="loading.TTPBBelumKembali"
        :items-per-page="5"
        class="elevation-1 mt-2"
        dense
      ></v-data-table>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { sync } from "vuex-pathify";

export default {
  name: "ContainerModal",
  props: ["openModal"],
  data() {
    return {
      loading: {
        saveData: false,
        TTPBBelumKembali: false
      },
      TTPBBelumKembaliHeaders: [
        { text: "TTPB", value: "ks" },
        { text: "Nomor Container", value: "container.no_container" },
        { text: "No TTB", value: "ttb.nottb" }
      ],
      TTPBBelumKembali: []
    };
  },
  methods: {
    async fetchData() {
      this.loading.TTPBBelumKembali = true;

      axios
        .get("laporan/ttpb-belum-kembali")
        .then(res => {
          this.TTPBBelumKembali = res.data;

          this.loading.TTPBBelumKembali = false;
        })
        .catch(err => {
          this.loading.TTPBBelumKembali = false;

          alert(err.response.data.message);
        });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}

table thead th {
  font-size: 12px !important;
}

.input {
  border: 1px solid lightgray;
  padding: 1px 4px;
  outline: none;
  width: 100%;
}

.w-100 {
  width: 100%;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

.no-wrap {
  white-space: nowrap;
}

.without_ampm::-webkit-datetime-edit-ampm-field {
  display: none;
}

input[type="time"]::-webkit-clear-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -ms-appearance: none;
  appearance: none;
  margin: -10px;
}
</style>
